import { useEffect, useState } from 'react';

/** Обновляет текущее время с поправкой на часы сервера */
export const useCurrentTime = (offset = 0): number => {
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        const timer = window.setInterval(() => setNow(Date.now()), 1000);

        return () => window.clearInterval(timer);
    }, []);

    return now + offset;
};
